<div class="select-busca" [class.aberto]="aberto" [class.desabilitado]="desabilitado">
  <div class="select-busca-campo" (click)="abrir(); inputBusca.focus()">
    <input
      #inputBusca
      type="text"
      class="form-control select-busca-input"
      autocomplete="off"
      [placeholder]="aberto && rotuloSelecionado ? rotuloSelecionado : placeholder"
      [disabled]="desabilitado"
      [value]="textoBusca"
      (focus)="abrir()"
      (input)="onDigitar($any($event.target).value)"
      (keydown)="onTecla($event)" />
    <button
      *ngIf="valor && !desabilitado"
      type="button"
      class="select-busca-limpar"
      title="Limpar"
      tabindex="-1"
      (mousedown)="$event.preventDefault()"
      (click)="limpar($event)">
      <i class="fas fa-times"></i>
    </button>
    <span class="select-busca-seta" (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation(); alternar()">
      <i class="fas" [class.fa-chevron-down]="!aberto" [class.fa-chevron-up]="aberto"></i>
    </span>
  </div>

  <div class="select-busca-dropdown" *ngIf="aberto">
    <ul #lista class="select-busca-lista" role="listbox">
      <li
        *ngFor="let o of filtradas; let i = index; trackBy: trackById"
        role="option"
        [class.ativo]="i === indiceAtivo"
        [class.selecionado]="o.id === valor"
        (mousedown)="$event.preventDefault()"
        (click)="selecionar(o)"
        (mouseenter)="indiceAtivo = i">
        {{ rotulo(o) }}
      </li>
      <li *ngIf="filtradas.length === 0" class="select-busca-vazio">Nenhum resultado encontrado.</li>
    </ul>
    <div class="select-busca-rodape" *ngIf="totalEncontradas > filtradas.length">
      Mostrando {{ filtradas.length }} de {{ totalEncontradas }}. Digite mais para refinar.
    </div>
  </div>
</div>
